import {makeAutoObservable} from "mobx";

export default class StatementStore {
    statement = []
    constructor() {
        makeAutoObservable(this)
    }

    setStatement(statement) {
        this.statement = statement
    }

}